import { TaxRate } from '@/types/taxRate';

/** Literal Types ────────────────────────────────────── */

export type MagazineStatusType = 'active' | 'inactive';

export type MagazineHubType = 'spot' | 'stage';

export type MagazineSaleStatusType = 'pre_sale' | 'on_sale' | 'end_sale';

export type MagazineSaleStatusItem = {
    value: MagazineSaleStatusType;
    label: string;
};

export const MagazineSaleStatus = {
    pre_sale: 'pre_sale',
    on_sale: 'on_sale',
    end_sale: 'end_sale',
} as const;

/** Item Types ───────────────────────────────────────── */

export type Magazine = {
    magazine_id: number;
    magazine_cd: string;
    magazine_type_cd: string;
    magazine_type_name: string;
    type_sort_order?: number;
    title_prefix?: string;
    title: string;
    status: MagazineStatusType;
    sale_status?: MagazineSaleStatusType;
    magazine_format: string;
    total_pages?: number;
    tax_category: string;
    is_tax_included: number;
    price: number;
    price_label?: string;
    supervisor_name?: string;
    model_number?: string;
    jan_code?: string;
    content: string;
    eyecatch_public_url?: string;
    has_detail?: boolean;
};

export type MagazinePage = {
    id: number;
    magazine_cd: number;
    sort_order: number;
    page_cd: string;
    extension: string;
    magazine_page_public_url?: string;
};

export type MagazineSeriesMagazine = Magazine & {
    magazine_series_hub_type: MagazineHubType;
    magazine_series_hub_series_cd: string;
    series_sort_order: number;
    series_step_label?: string;
};

export type MagazineSeriesCategory = {
    magazine_series_category_cd: string;
    name: string;
    sort_order: number;
};

export type MagazineSeries = {
    magazine_series_id: number;
    hub_type: MagazineHubType;
    hub_series_cd: string;
    categories: MagazineSeriesCategory[];
    sort_order: number;
    name: string;
    description: string;
    status: MagazineStatusType;
    magazines: MagazineSeriesMagazine[];
};

/** Condition Types ──────────────────────────────────── */

/** Form Types ───────────────────────────────────────── */

/** Response ──────────────────────────────────────────── */

export type MagazineResponse = {
    magazines: Magazine[];
    magazine_series: MagazineSeries[];
    tax_rates: TaxRate[];
};

export type MagazinePageResponse = {
    magazine: Magazine;
    magazine_pages: MagazinePage[];
};

export type MagazineSeriesDetailResponse = {
    magazine_series: MagazineSeries | null;
    tax_rates: TaxRate[];
};
